/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * HockeyUSAIcon component - Icon for USA Hockey question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const HockeyUSAIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18V6ZM5 7V17H19V7H5Z'
        fill={color}
      />
      <path d='M7 9H17V11H7V9Z' fill={color} />
      <path d='M7 13H14V15H7V13Z' fill={color} />
      <circle cx='16' cy='14' r='1' fill={color} />
      <path d='M10 3L12 1L14 3H10Z' fill={color} />
      <path d='M10 21L12 23L14 21H10Z' fill={color} />
    </svg>
  )
}

export default HockeyUSAIcon
